import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthorizedGuard } from 'src/app/shared/guards';

import { GroupsContainerComponent } from './groups-container/groups-container.component';
import { GroupViewComponent } from './group-view/group-view.component';

const routes: Routes = [
  {
    path: 'clubs',
    component: GroupsContainerComponent,
    data: { type: GroupsContainerComponent.Type.Clubs }
  },
  {
    path: 'subscribed-clubs',
    component: GroupsContainerComponent,
    data: { type: GroupsContainerComponent.Type.SubscribedClubs },
    canActivate: [AuthorizedGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'private',
    component: GroupsContainerComponent,
    data: { type: GroupsContainerComponent.Type.Private },
    canActivate: [AuthorizedGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'subscribed-private',
    component: GroupsContainerComponent,
    data: { type: GroupsContainerComponent.Type.SubscribedPrivate },
    canActivate: [AuthorizedGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'request/:id',
    component: GroupViewComponent,
    runGuardsAndResolvers: 'always'
  },
  {
    path: ':id',
    component: GroupViewComponent,
    runGuardsAndResolvers: 'always'
  },
  {
    path: ':id/:name',
    component: GroupViewComponent,
    runGuardsAndResolvers: 'always'
  },
  {
    path: ':id/:name/:section',
    component: GroupViewComponent,
    runGuardsAndResolvers: 'always'
  },
  {
    path: ':id/:name/:section/:page',
    component: GroupViewComponent,
    runGuardsAndResolvers: 'always'
  },
  {
    path: ':id/:name/:section/:mediaType/:page',
    component: GroupViewComponent,
    runGuardsAndResolvers: 'always'
  },
  {
    path: '',
    redirectTo: 'clubs',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'clubs',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GroupsRoutingModule {}
